var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2929 5.58006C12.6834 5.18954 13.3166 5.18954 13.7071 5.58006L19.7071 11.5801C19.8946 11.7676 20 12.022 20 12.2872C20 12.5524 19.8946 12.8067 19.7071 12.9943L13.7071 18.9943C13.3166 19.3848 12.6834 19.3848 12.2929 18.9943C11.9024 18.6038 11.9024 17.9706 12.2929 17.5801L16.5858 13.2872L5 13.2872C4.44772 13.2872 4 12.8395 4 12.2872C4 11.7349 4.44772 11.2872 5 11.2872L16.5858 11.2872L12.2929 6.99427C11.9024 6.60375 11.9024 5.97059 12.2929 5.58006Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.21b6bdccf5a6969e84c2f6424f36fd20.svg";
export { ForwardRef as ReactComponent };